import { PaymentTransactionListPage } from "@/features/payment-transaction/pages/PaymentTransactionListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/payment-transaction/")({
	validateSearch: (search: Record<string, unknown>) => search,
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: ["it.monitoring.payment_transaction"],
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: PaymentTransactionListPage,
});
